<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-3">
<h1>Chapter 3</h1>
<p>Monday morning, Sales Leadership Meeting</p>
<p>Chair: John Clark, Managing Director Sales and Implementation</p>
<p>Time: 8:30am</p>
<p>Agenda:</p>
<ul style="list-style: none;">
<li><p>- Last week sales figures</p></li>
<li><p>- Scheduled customer contact activity</p></li>
<li><p>- Major contract review</p></li>
<li><p>- Other operational matters</p></li>
<li><p>- Any other business</p></li>
</ul>
<p>Attendees:</p>
<ul style="list-style: none;">
<li><p>- Nicky Chan (Regional Sales Manager)</p></li>
<li><p>- Alan Driver (Regional Sales Manager)</p></li>
<li><p>- Todd Kowalski (Major Contracts Manager)</p></li>
<li><p>- Ash Kumar (Head of Implementation)</p></li>
<li><p>- Melissa Edmonds (HR)</p></li>
<li><p>- Steve Williams (Risk)</p></li>
</ul>
<p>Meeting Transcript:</p>
<p>John: …guys…can you hear me…sorry…internet keeps…out…</p>
<p>Nicky: John you’ve frozen…no wait, we’ve got you…</p>
<p>John: …through last week’s numbers…then…</p><br/>
<p style="text-align: center;">***************</p><br/>
<p>Todd: John?…John? We can’t hear you. Try logging out then in again. He’s gone. I guess we’ll give him a minute to join us again.</p>
<p>Nicky: So, have you closed your big government deal yet, Todd? Can we finally stop hearing about how you’re going to save the day or are you still struggling to get it over the line?</p>
<p>Todd: Thanks for your support, Nicky. You know what I reckon…</p>
<p>Melissa: Ah, hi John.</p>
<p>John: Hi team, sorry about that. Internet issues. Can you hear me OK now? Great. Suggest we stick with the usual agenda. Nicky, let’s start with you. How’s Northern region going?</p>
<p>Nicky: Great. Three contracts closed last week, including the Jamieson one which should drop ‘fifty k’ to the bottom line. Based on Feb numbers we’re five percent ahead of plan so with these new wins we should close the year at least six percent ahead. We dropped five new opportunities into the pipeline last week, including a potential deal for Shell on a new venture they’re starting. The team are pumped about that one. Eighty-five customer contacts scheduled for this week, sixteen of them with prospects.</p>
<p>John: Great week, well done Team Northern. Let’s get Todd’s team engaged on the Shell contract.</p>
<p>Nicky: I reckon we’ve got that one covered, John. It’s not a huge new venture but if it turns into something bigger in time then we can get Major Contracts involved.</p>
<p>John: Best to engage them now. Great opportunity for both your teams to work together. Build some collaboration and get the best of both worlds—major contact experience and local relationships. Thanks, Nicky. Alan, let’s go to you. How’s Southern?</p>
<br/>
<p style="text-align: center;">***************</p><br/>
<p>John: Alan, you’re on mute…</p>
<br/>
<p style="text-align: center;">***************</p><br/>
<p>John: Alan…Alan, you are on mute. Turn mute off.</p>
<p>Alan: oh…er…sorry. Can you hear me now? Sorry about that.</p>
<p>John: That’s ok. Let’s get your update, Alan.</p>
<p>Alan: Sure. So, I’ve had some problems with the system this morning so I don’t have much of a pipeline update. I think we’re still waiting to hear about most of the key deals.</p>
<p>Things seem to be moving really slow at the moment, what with this Coronavirus thing.</p>
<p>Ash: Alan, I believe Vic in your team has closed one or maybe more of his deals last week because he contacted my team to ensure they are ready. Perhaps you should check with him?</p>
<p>Alan: Oh great, thanks Ash. I’ll check in with Vic and let you all know.</p>
<p>John: Right. And how are your Feb numbers, Al?</p>
<p>Alan: Yeah, still tracking a bit behind John, but I’m sure we’ll catch up. Still got a few months.</p>
<p>John: Why don’t you catch up off line with Nicky, see if there’s some best practice which Northern region can share?</p>
<p>Alan: That’s a really great idea John, thanks, I’ll do that. Nicky, I’ll call you after this, ok?</p>
<p>Nicky: Sure…</p>
<p>John: OK Todd, talk to us. Are we there yet?</p>
<p>Todd: Not quite, but we got an approval from the sub-committee last week which is a major landmark. There’s no way the minister can even consider it without support from the sub-committee, so that’s real cause for celebration. You know how slow these government bureaucracies move.</p>
<p>John: Yep. Got anything else hotting up, Todd?</p>
<p>Todd: Its looking great actually. We’ve got a few promising things we’re working on, but at a much earlier stage. I’ll provide detailed updates as things get more advanced.</p>
<p>Nicky: Let us know if there’s anything we can help with Todd. Remind me what you’re calling your government deal?</p>
<p>Todd: It’s called Project Endeavour.</p>
<p>John: This one’s massive for us. It’ll move the share price considerably if we win it. We need to move heaven and earth to close it. Todd, lets you and I catch up after this to go through the latest detail. I want to leave no stone unturned.</p>
<p>Todd: Sure thing.</p>
<p>John: OK, Ash, how’re our implementation champs?</p>
<p>Ash: Quite good thank you.</p>
<p>Ash: So, would you like me to do my update now, John?</p>
<p>John: Er, yes please Ash, that’s why I passed over to you.</p>
<p>Ash: Ah, right, OK. So, capacity utilisation is satisfactory at 76%. However, I must tell you John that I have not yet factored in the new Northern team contract wins so I will need to re-do the calculations after this meeting. I am sorry for my oversight, John.</p>
<p>John: That’s really fine Ash. I’m sure it won’t affect things too much.</p>
<p>Ash: OK, thank you, John. Would you like me to continue with my update John?</p>
<p>John: That’d be great…</p>
<p>Ash: Right. We also completed a post implementation review last week for Project Horizon and our rating matrix returned 5 green and 3 amber categories which is satisfactory. Also, we will be implementing some adjustments to our Kaizen methodology which we expect to produce an extra 3% capacity in our Scoping and Design team.</p>
<p>John: Great. Sounds exciting.</p>
<p>Ash: Yes, thank you John, it is indeed. Finally, I intend to monitor team productivity closely this week because everyone is now working from home.</p>
<p>John: Don’t most of your team work remotely anyway, from clients’ offices?</p>
<p>Ash: Of course. But being at home is a different thing. It is harder for me to monitor staff, you know.</p>
<p>John: If we need to be looking over their shoulders Ash then we’ve got the wrong people. We should be setting our people a goal and then providing all the support they need to achieve it. Trust is a powerful force if you’ve got it and a big problem if you don’t.</p>
<p>Alright, any feedback for Ash’s team?</p>
<br/>
<p style="text-align: center;">***************</p><br/>
<p>John: Alan, you’re on mute again…Alan, mute…</p>
<br/>
<p style="text-align: center;">***************</p><br/>
<p>Alan: Sorry. I just wanted to say that’s a great point about trust, John. Completely agree at a time like this that we trust and empower our teams. In terms of the implementation team, I think they did a really great job with Project Horizon. Please pass on my congratulations to your whole team Ash.</p>
<p>John: Yep, agree. Great work. Anything else?</p>
<p>Todd: I think we should start planning for implementation of Project Endeavour because if it lands, we will need to respond quickly and it will need a lot of resource.</p>
<p>Nicky: Maybe we should consider dedicating implementation resource to each of the sales teams so we can all have confidence that we can execute for our customers.</p>
<p>John: No. Todd I want to go through your deal in more detail before we consider ring-fencing resource. Ok, thanks team, I reckon that’s about it. Anything else anyone wants to raise?</p>
<p>Steve: John did you want me to provide a risk update this morning?</p>
<p>John: Oh, yeah, sorry Steve. Go ahead…</p>
<p>Steve: Thank you. I hope you all saw my email on Friday afternoon last week about our new fraud policy guidelines. There was a bit of information in there but important you and your teams understand it all in detail. I thought I’d run you through the key points now and then you can read at your leisure later. So, first of all…</p>
<p>John: Steve how about we assume the team will read the information and come to you with any questions. Was there anything else you wanted to cover?</p>
<p>Steve: Er, ok. Sure. I’d be happy to discuss any questions any of you might have. I’ll call you all individually after this meeting to go through everything. We have also just launched our new online risk training platform, which is a very exciting development and should really bring the subject to life for our people. We’ve been working on this for the last six months in the risk team so it’s great to see it go live. Can I ask if anyone has used it yet, or if any of your teams have done so?</p>
<p>John: OK thanks Steve, great update. Any questions for Steve?</p>
<p>Nicky: Nah.</p>
<p>Todd: Nope.</p>
<br/>
<p style="text-align: center;">***************</p><br/>
<p>John: Great, thanks Steve. Mel, any people issues we need to talk about?</p>
<p>Mel: Nope. All good.</p>
<p>Steve: Err…</p>
<p>John: Great, thanks team. That’s a wrap. Good luck with the transition to working from home. It’ll certainly take me some adjustment so take care of yourselves and let’s try to keep the team focused on what matters. No doubt, speak to you all during the week.</p>
<p>Ash: Thank you everyone…</p>
<p>Todd: Thanks John, speak to you later.</p>
<p>Nicky: Good luck with that deal Todd. Catch you all next time.</p>
<br/>
<p style="text-align: center;">***************</p><br/>
<p>Meeting ends.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?14ae7260